import { Img } from "Components/index";
import { Popover, PopoverButton, PopoverPanel, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Swal from "sweetalert2";
const KarwanPage = () => {
  const navigation = [
    { name: "Home", href: "#home" },
    { name: "Features", href: "#features" },

    { name: "Get Application", href: "#application" },
  ];
  const handleComingSoon = () => {
    Swal.fire({
      icon: "success",
      title: "Coming soon!",
      showConfirmButton: false,
      timer: 2000,
    });
  };

  return (
    <>
      <div id="home" className="relative overflow-hidden bg-white">
        <div className="mx-auto max-w-7xl">
          <div className="relative z-10  pb-8 sm:pb-16 md:pb-20 lg:w-full lg:max-w-2xl lg:pb-28 xl:pb-32">
            <svg
              className="absolute inset-y-0 right-0 hidden h-full w-48 translate-x-1/2 transform text-white lg:block"
              fill="currentColor"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <polygon />
            </svg>

            <Popover>
              <div className="relative px-4 pt-6 sm:px-6 lg:px-8">
                <nav
                  className="relative  flex items-center justify-between sm:h-10 lg:justify-start"
                  aria-label="Global"
                >
                  <div className="flex flex-shrink-0 flex-grow items-center lg:flex-grow-0">
                    <div className="flex w-full items-center justify-between md:w-auto">
                      <a href="#home">
                        <span className="sr-only">Your Company</span>
                        <img
                          alt="Your Company"
                          className="h-8 w-auto sm:h-10"
                          src="images/img_navlogo.png"
                        />
                      </a>
                      <div className="-mr-2 flex items-center md:hidden">
                        <PopoverButton className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#008552]">
                          <span className="sr-only">Open main menu</span>
                          <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                        </PopoverButton>
                      </div>
                    </div>
                  </div>
                  <div className="hidden  md:ml-10 md:block md:space-x-8 md:pr-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="font-medium text-gray-500 hover:text-[#008552]"
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </nav>
              </div>

              <Transition
                enter="duration-150 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <PopoverPanel
                  focus
                  className="absolute inset-x-0 top-0 z-10 origin-top-right transform p-2 transition md:hidden"
                >
                  <div className="overflow-hidden rounded-lg bg-white shadow-md ring-1 ring-black ring-opacity-5">
                    <div className="flex items-center justify-between px-5 pt-4">
                      <div>
                        <img
                          className="h-8 w-auto"
                          src="images/img_navlogo.png"
                          alt=""
                        />
                      </div>
                      <div className="-mr-2">
                        <PopoverButton className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#008552]">
                          <span className="sr-only">Close main menu</span>
                          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </PopoverButton>
                      </div>
                    </div>
                    <div className="space-y-1  px-2 pt-2 pb-3">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className="block bg-gray-50 hover:bg-green-50  rounded-md px-3 py-2 text-base font-medium text-gray-700  hover:text-[#008552]"
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  </div>
                </PopoverPanel>
              </Transition>
            </Popover>

            <main className="mx-auto mt-10 max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              <div className="sm:text-center lg:text-left">
                <h1 className="text-4xl  font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
                  <span className="block  text-[#002618] xl:inline">
                    Pakistan’s{" "}
                  </span>{" "}
                  <span className="block text-[#008552] xl:inline">
                    most innovative Carpool App
                  </span>
                </h1>
                <p className="mt-3 text-base text-gray-500 sm:mx-auto sm:mt-5 sm:max-w-xl sm:text-lg md:mt-5 md:text-xl lg:mx-0">
                  The idea for Karwan was sparked from individual experiences
                  because of the inflationary impact due to the skyrocketing
                  inflation rate of fuel. Karwan aims to become a Nationwide
                  network for carpooling connecting every commuter at every
                  level. Sath Jao, Pasay Bachao
                </p>
                <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                  <div className="rounded-md shadow">
                    <a
                      href="#application"
                      className="flex w-full items-center justify-center rounded-md border border-transparent bg-[#008552] px-8 py-3 text-base font-medium text-white hover:bg-[#008552] md:py-4 md:px-10 md:text-lg"
                    >
                      Get started
                    </a>
                  </div>
                  <div className="mt-3 sm:mt-0 sm:ml-3">
                    <a
                      href="https://www.linkedin.com/company/karawanpk/"
                      target="_blank"
                      rel="noreferrer"
                      className="flex w-full items-center justify-center rounded-md border border-transparent bg-green-100 px-8 py-3 text-base font-medium text-[#008552] hover:bg-green-200 md:py-4 md:px-10 md:text-lg"
                    >
                      Contact us
                    </a>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
        <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
          <img
            className=" w-full object-cover object-left-bottom lg:object-contain  sm:h-72 md:h-96 lg:h-full lg:w-full"
            src="images/img_heroimage.png"
            alt=""
          />
        </div>
      </div>

      <div id="google" className="relative overflow-hidden bg-white ">
        <div className="mx-auto max-w-7xl ">
          <div className="relative w-full bz-10  pb-8 sm:pb-16 md:pb-20   lg:pb-28 xl:pb-32">
            <div className="flex  mx-auto mt-10 max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              <img
                className=" flex w-[40%]    object-right-bottom object-contain  "
                src="images/model.png"
                alt=""
              />
              <img
                className="flex w-[60%]   object-right-bottom object-contain  "
                src="images/mobileScreens.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div id="features" className="relative overflow-hidden bg-white">
        <div className="mx-auto max-w-7xl ">
          <div className="relative  w-full  z-10   ">
            <div className="flex  ">
              <div className=" flex flex-col mt-16 bg-gradient3    w-[100%]">
                <div className="flex flex-col items-center mb-1 lg:mb-16 ">
                  <p className=" pt-5 text-center pl-20 pr-20 text-sm font-normal tracking-tight text-gray-900 sm:text-1xl md:text-2xl">
                    <span className="block font-inter font-bold text-[18px] text-[#008552] xl:inline">
                      Our Community
                    </span>{" "}
                  </p>
                  <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
                    <span className="block  text-[#002618] xl:inline">
                      Karwan Features{" "}
                    </span>{" "}
                  </h1>
                  <p className=" pt-5 text-center pl-20 pr-20 text-sm font-normal tracking-tight text-gray-900 sm:text-1xl md:text-2xl">
                    <span className="block font-inter text-sm text-gray_700 xl:inline">
                      Karwan aims to become a Nationwide network for carpooling
                      connecting every commuter at every level
                    </span>{" "}
                  </p>
                </div>

                <div className="   grid grid-cols-1 gap-10 md:grid-cols-2 p-20">
                  <div className="bg-white_A700 hover:cursor-pointer   pt-7  pb-7 flex flex-col xsm:flex-row    rounded-radius14 hover:shadow-bs6 hover:w-[100%] w-[100%]">
                    <div className=" w-full m-5 flex flex-row">
                      <div className="flex ml-10 w-[10vh] md:w-[30%] lg:w-[20%] ">
                        <Img
                          src="images/1.png"
                          className=" object-contain scale-150"
                          alt="user"
                        />
                      </div>
                      <div className=" flex  flex-col m-5 mt-3 w-full">
                        <span className="  text-xl font-bold block text-[#002618] xl:inline">
                          Social Verifcation
                        </span>

                        <span className=" hidden sm:block  text-gray_700 xl:inline">
                          Levels of Reliability via social accounts
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white_A700 hover:cursor-pointer   pt-7  pb-7 flex flex-col xsm:flex-row    rounded-radius14 hover:shadow-bs6 hover:w-[100%] w-[100%]">
                    <div className=" w-full m-5 flex flex-row">
                      <div className="flex ml-10 w-[10vh] md:w-[30%] lg:w-[20%] ">
                        <Img
                          src="images/2.png"
                          className=" object-contain scale-150"
                          alt="user"
                        />
                      </div>
                      <div className=" flex  flex-col m-5 mt-3 w-full">
                        <span className="  text-xl font-bold block text-[#002618] xl:inline">
                          Pooling Parcels
                        </span>

                        <span className=" hidden sm:block  text-gray_700 xl:inline">
                          Low delivery charges
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white_A700 hover:cursor-pointer   pt-7  pb-7 flex flex-col xsm:flex-row    rounded-radius14 hover:shadow-bs6 hover:w-[100%] w-[100%]">
                    <div className=" w-full m-5 flex flex-row">
                      <div className="flex ml-10 w-[10vh] md:w-[30%] lg:w-[20%] ">
                        <Img
                          src="images/3.png"
                          className=" object-contain scale-150"
                          alt="user"
                        />
                      </div>
                      <div className=" flex  flex-col m-5 mt-3 w-full">
                        <span className="  text-xl font-bold block text-[#002618] xl:inline">
                          Real time commute
                        </span>

                        <span className=" hidden sm:block  text-gray_700 xl:inline">
                          Real time google location
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white_A700 hover:cursor-pointer   pt-7  pb-7 flex flex-col xsm:flex-row    rounded-radius14 hover:shadow-bs6 hover:w-[100%] w-[100%]">
                    <div className=" w-full m-5 flex flex-row">
                      <div className="flex ml-10 w-[10vh] md:w-[30%] lg:w-[20%] ">
                        <Img
                          src="images/4.png"
                          className=" object-contain scale-150"
                          alt="user"
                        />
                      </div>
                      <div className=" flex  flex-col m-5 mt-3 w-full">
                        <span className="  text-xl font-bold block text-[#002618] xl:inline">
                          Intuitive Design
                        </span>

                        <span className=" hidden sm:block text-gray_700 xl:inline">
                          User friendly design
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mb-20 sm:mb-0 overflow-hidden bg-white ">
        <div id="application" className=" mx-auto max-w-7xl ">
          <div className="relative w-full bz-10  ">
            <div className="flex  mx-auto mt-10 max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              <div className="  flex w-[50%]    object-right-bottom object-contain   ">
                <div className="flex flex-col z  ">
                  <div className="text-[18px] font-medium  text-[#008552]">
                    Get our Application
                  </div>
                  <div className="text-[30px] font-bold">
                    {" "}
                    You Can Easily Find This App…!
                  </div>

                  <div className="text-[16px] ">
                    Download the appication and get first five rides for free
                    <span className="  text-[#008552] font-bold">
                      {" "}
                      #SathJaoPasayBachao
                    </span>
                  </div>

                  <div className="  mt-5  ">
                    <img
                      onClick={handleComingSoon}
                      className="flex w-[45%] cursor-pointer object-contain xsm:ml-2 sm:ml-3 md:ml-4 lg:ml-5  object-top "
                      src="images/comingsoon.png"
                      alt="Download on the App Store"
                    />

                    <a
                      href="https://play.google.com/store/apps/details?id=com.karawan"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="flex w-[60%] cursor-pointer object-contain  object-top "
                        src="images/comingsoon2.png"
                        alt="Get it on Google Play"
                      />
                    </a>
                  </div>

                  <img
                    className="   w-[80%] mt-[10vh] self-center  hidden md:flex   object-left-bottom object-contain  "
                    src="images/car.png"
                    alt=""
                  />
                </div>
              </div>

              <img
                className="flex w-[60%]   object-contain  object-top "
                src="images/mobile.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="relative  overflow-hidden bg-white ">
        <div className="mx-auto  ">
          <div className="flex items-center  pl-10 pr-10 justify-between h-[60px] bg-[#002618] ">
            <div className="text-white hidden md:flex">
              Pakistan’s most innovative Carpool App
            </div>
            <Img
              src="images/karawan.png"
              className="  object-contain   "
              alt="user"
            />
            <div className="flex flex-row">
              <a
                href="https://instagram.com/karawan.pk"
                target="_blank"
                rel="noreferrer"
              >
                <Img
                  src="images/insta-btn.png"
                  className=" mr-5 object-contain  hidden sm:flex  "
                  alt="user"
                />
              </a>

              <a
                href="https://www.linkedin.com/company/karawanpk/"
                target="_blank"
                rel="noreferrer"
              >
                <Img
                  src="images/linkedin-btn.png"
                  className=" hidden object-contain sm:flex     "
                  alt="user"
                />
              </a>
              <a
                href="https://instagram.com/karawan.pk"
                target="_blank"
                rel="noreferrer"
              >
                <Img
                  src="images/roundedinsta.png"
                  className=" mr-5 object-contain sm:hidden  flex  "
                  alt="user"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/karawanpk/"
                target="_blank"
                rel="noreferrer"
              >
                <Img
                  src="images/roundedlink.png"
                  className="  object-contain sm:hidden  flex    "
                  alt="user"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KarwanPage;
